import { Checkbox, FormControl, Input, InputLabel, ListItemText, MenuItem, Select } from '@material-ui/core';
import React, { FC } from 'react';
import { createUseStyles } from 'src/theming';

const useStyles = createUseStyles({
  root: {
    minWidth: '120px !important',
    maxWidth: 300,
  },
});

const status = {
  toBilled: 'A facturer',
  hasContract: 'Contrat',
};

interface Props {
  onChange: (value: Array<string>) => void;
  value: Array<string>;
}

const StatusSelect: FC<Props> = ({ onChange, value }) => {
  const classes = useStyles();

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    onChange(event.target.value as string[]);
  };

  return (
    <FormControl className={classes.root}>
      <InputLabel>Statut</InputLabel>
      <Select
        multiple
        value={value}
        onChange={handleChange}
        input={<Input />}
        renderValue={(selected) => (selected as string[]).map((key) => status[key]).join(', ')}
      >
        {Object.keys(status).map((statusKey) => (
          <MenuItem key={statusKey} value={statusKey}>
            <Checkbox checked={value && value.indexOf(statusKey) > -1} />
            <ListItemText primary={status[statusKey]} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StatusSelect;
